import { X } from 'lucide-react';
import { useNavigate } from 'react-router';
import { useUi } from '../store/ui';
import { Avatar } from './Avatar';

/** In-App-Benachrichtigungen und Statusmeldungen (unten rechts, aria-live). */
export function Toasts() {
  const toasts = useUi((s) => s.toasts);
  const dismiss = useUi((s) => s.dismissToast);
  const navigate = useNavigate();
  return (
    <div className="toasts" aria-live="polite" data-testid="toasts">
      {toasts.map((t) => (
        <div
          key={t.id}
          className="toast"
          data-kind={t.kind}
          data-testid={`toast-${t.kind}`}
          role={t.kind === 'error' ? 'alert' : 'status'}
          data-clickable={t.to ? 'true' : undefined}
          onClick={() => {
            if (t.to) {
              void navigate(t.to);
              dismiss(t.id);
            }
          }}
        >
          {t.kind === 'notification' && t.iconUrl !== undefined && (
            <Avatar user={{ id: '0', username: t.title, displayName: null, avatarUrl: t.iconUrl ?? null, avatarAnimated: false }} size={32} />
          )}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="toast-title">{t.title}</div>
            {t.body && <div className="toast-body">{t.body}</div>}
          </div>
          <button
            className="icon-btn"
            style={{ width: 24, height: 24 }}
            aria-label="Meldung schließen"
            onClick={(e) => {
              e.stopPropagation();
              dismiss(t.id);
            }}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
